import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export { api as default };

export function useAuthApply() {
  const { applyAuth } = useAuth();
  return applyAuth;
}
